const insType = [{
  desc: '查询系统险种',
  options: {
    url: '/insType/querySysInsuranceTypeCode',
    method: 'post'
  }
}]
export default insType



// WEBPACK FOOTER //
// ./src/api/insType.js